export interface ILanguage {
    code:string;
    name:string;
}


export const defaultLanguage: ILanguage = {
    code: 'english', 
    name: 'English'
};